import type { IDocument } from "@bbj-types/document";
import { Stack, Tooltip } from "@mui/material";
import { UploadFileFieldDocument } from "./document";
import { useUploadFileField } from "./logics";
import { UploadFileFieldSelect } from "./select";
import type { IUploadFileFieldOptions } from "./types";

export const UPLOAD_FILE_FIELD_BUTTON_HEIGHT = 32;

export interface IUploadFileFieldProps {
  /** @default "Ajouter une pièce jointe" */
  label?: string;
  selectableDocuments?: IDocument[];
  /** @default "Depuis les fichiers de mon ordinateur" */
  labelSelectFromComputer?: string;
  /** @default "Depuis le centre de documents du candidat" */
  labelSelectFromSelectableDocuments?: string;
  onChange?: (documents: IDocument[]) => void;
  onLoading?: (loading: boolean) => void;
  options?: IUploadFileFieldOptions;
}

export const UploadFileField = ({
  label = "Ajouter une pièce jointe",
  selectableDocuments = [],
  labelSelectFromComputer = "Depuis les fichiers de mon ordinateur",
  labelSelectFromSelectableDocuments = "Depuis le centre de documents du candidat",
  onChange,
  onLoading,
  options = {},
}: IUploadFileFieldProps) => {
  const { documents, loading, handleRemove, handleInputFileChange, handleSelectedDocuments } = useUploadFileField(
    selectableDocuments,
    onChange,
    onLoading,
    options
  );

  return (
    <Stack
      sx={{
        alignItems: "start",
        gap: 2,
      }}
    >
      {loading ? (
        <Tooltip
          title="Des document sont en cours de téléchargement. Veuillez patienter quelques secondes avant de les voir apparaître."
          arrow
        >
          <span>
            <UploadFileFieldSelect
              label={label}
              loading={loading}
              documents={documents}
              selectableDocuments={selectableDocuments}
              labelSelectFromSelectableDocuments={labelSelectFromSelectableDocuments}
              labelSelectFromComputer={labelSelectFromComputer}
              onInputFileChange={handleInputFileChange}
              onSelectedDocuments={handleSelectedDocuments}
            />
          </span>
        </Tooltip>
      ) : (
        <UploadFileFieldSelect
          label={label}
          loading={loading}
          documents={documents}
          selectableDocuments={selectableDocuments}
          labelSelectFromSelectableDocuments={labelSelectFromSelectableDocuments}
          labelSelectFromComputer={labelSelectFromComputer}
          onInputFileChange={handleInputFileChange}
          onSelectedDocuments={handleSelectedDocuments}
        />
      )}
      <Stack
        {...(documents.length < 1 && { display: "none" })}
        sx={{
          alignItems: "stretch",
          gap: 1.5,
          maxWidth: "100%",
        }}
      >
        {documents.map((document) => (
          <UploadFileFieldDocument key={document._id} document={document} handleRemove={handleRemove} />
        ))}
      </Stack>
    </Stack>
  );
};
